// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@conklin/XDL/Utilities";
import { LinkPresentationProps, StyledTypography } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const headerText: TypographyPresentationProps = {
    size: 14,
    weight: fontConfig.weight.bold,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 17px;
        margin: 16px 0 12px 0;
    `,
};

export const textStyles: TypographyPresentationProps = {
    size: 12,
    weight: fontConfig.weight.regular,
    color: "text",
    lineHeight: "15px",
    css: css`
        letter-spacing: 0;
        line-height: 15px;
        margin-bottom: 0;
    `,
};

export const linkStyles: LinkPresentationProps = {
    typographyProps: textStyles,
    css: css`
        && {
            ${StyledTypography} {
                color: ${color("text.link")};
            }

            &:hover {
                ${StyledTypography} {
                    color: ${color("common.ui10")};
                }
            }
        }
    `,
};

export const itemText: TypographyPresentationProps = {
    ...textStyles,
    css: css`
        margin-bottom: 12px;
        span > b {
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};
export const focusedItemText: TypographyPresentationProps = {
    ...mergeWithCss(textStyles, {
        css: css`
            background: ${color("common.ui3")};
            margin-bottom: 12px;
        `,
    }),
};
